// extracted by mini-css-extract-plugin
export default {"wrapper":"payment-success_wrapper--nhOZF","title":"payment-success_title--LXK8g","description":"payment-success_description--JJQgf"};